import React from 'react';

import profileIcon from '../../images/contact-icon.png';

import { FitContentSectionWrapper } from '../../ui/wrappers';
import { TitleWrapper } from '../../ui/titles';
import { H3 } from '../../ui/headings';
import { FlexContainer } from '../../ui/flex';
import {
    CityContainer,
    CityP,
    Name,
    ProfileContainer,
    ProfileHeaderContainer,
    ProfileImg,
    ProfileImgWrapper,
    ProfileInfoContainer,
    Role,
} from '../../ui/contact-me/contact-me';

import Social from './Social';

const ContactMe = () => (
    <FitContentSectionWrapper id='contact-me' style={{ paddingBottom: '5em' }}>
        <FlexContainer $column $content='center' $gap='5em'>
            <TitleWrapper>
                <H3>Contact Me</H3>
            </TitleWrapper>

            <ProfileContainer>
                <ProfileHeaderContainer>
                    <ProfileInfoContainer>
                        <ProfileImgWrapper>
                            <ProfileImg src={profileIcon} alt='G-Eazy' />
                        </ProfileImgWrapper>

                        <div>
                            <Role>Fullstack Software Engineer</Role>
                            <Name>Reito Serizawa</Name>
                            <Social />
                        </div>
                    </ProfileInfoContainer>

                    <CityContainer>
                        <CityP>New York, NY</CityP>
                    </CityContainer>
                </ProfileHeaderContainer>
            </ProfileContainer>
        </FlexContainer>
    </FitContentSectionWrapper>
);

export default ContactMe;
